(ns app.front.ui.editable-attr
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [core.util.util :as util]
            [reagent.core :as r]))

(defn ghost-button [props]
  (cc/button (merge {:kind     :ghost
                     :size     :small
                     :disabled false}
                    props)
             (:title props)))

(defn edit-buttons [{:keys [tr *value value on-change confirm-content]}]
  (if (-> @*value nil? not)
    [:div.flex.flex-row.justify-end.pt-1
     [ghost-button {:title    (tr [:cancel])
                    :on-click #(reset! *value nil)}]
     [ghost-button {:title    (tr [:save])
                    :disabled (or (= @*value (or value ""))
                                  (nil? on-change))
                    :on-click #(do
                                 (on-change @*value)
                                 (reset! *value nil))}]]
    (when on-change
      (let [button-opts {:kind             :ghost
                         :icon             i/pen
                         :icon-position    :right
                         :class-name       "bottom-0 max-h-4"
                         :size             :small
                         :icon-description (tr [:edit])
                         :on-click         #(reset! *value (or value ""))}]
        [:div.flex.flex-row.justify-end.pt-1
         (if (nil? confirm-content)
           (cc/button button-opts (tr [:edit]))
           [ui/modal-confirmation-button
            {:id                  "add-form-button"
             :tr                  tr
             :trigger-button-text (tr [:edit])
             :trigger-button-opts (dissoc button-opts :on-click)
             :on-yes-click        (:on-click button-opts)}
            confirm-content])]))))

(defn editable-attr [{:keys [value on-change text-container opts header-element loading? tr confirm-content]}]
  (r/with-let [*value (r/atom nil)]
    (let [editing? (-> @*value nil? not)]
      [:div.flex.flex-1.flex-col.justify-between.h-full
       [:<>
        [:div.flex.flex-col
         (when header-element
           [:div.flex.flex-row header-element])
         (if editing?
           [:div.w-full
            [ui/text-area  {:value     @*value
                            :on-change #(->> % futil/tval (reset! *value))
                            :light     true}]]
           [:div.flex.flex-row.h-full
            (if loading?
              (cc/skeleton-text)
              [(or text-container :span)
               opts
               (if (str/blank? value) "-" value)])])]
        [edit-buttons (util/mmap editing? tr *value value on-change confirm-content)]]])))
